// libs
import React, { memo } from 'react';

//styles
import { SearchContainer, InputSearchIcon, CloseIcon, InputField } from './styles';

//constants
import { SEARCH, SEARCH_ICON_SIZE, CLOSE_ICON_SIZE } from './constants';

// types
import { Theme } from '@nykaa/ui-components/themes/types';

//hook
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';

// defs
interface ISearchBar {
  searchText: string;
  title: string;
  setSearchText: (text: string) => void;
}

function SearchBar({ searchText, setSearchText, title }: ISearchBar) {
  const theme: Theme = useTheme();

  return (
    <SearchContainer>
      <InputSearchIcon size={SEARCH_ICON_SIZE} color={theme.colors.textSecondary} />
      <InputField
        type="text"
        placeholder={`${SEARCH} ${title}`}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
      {searchText.length > 0 && (
        <CloseIcon
          size={CLOSE_ICON_SIZE}
          onClick={() => setSearchText('')}
          color={theme.colors.textDisabled}
        />
      )}
    </SearchContainer>
  );
}

export default memo(SearchBar);
